import { render, staticRenderFns } from "./merchantsSettlement.vue?vue&type=template&id=82e8a150&scoped=true&"
import script from "./merchantsSettlement.vue?vue&type=script&lang=js&"
export * from "./merchantsSettlement.vue?vue&type=script&lang=js&"
import style0 from "./merchantsSettlement.vue?vue&type=style&index=0&id=82e8a150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e8a150",
  null
  
)

export default component.exports